import * as wasm from "./template_web_bg.wasm";
export * from "./template_web_bg.js";
import { __wbg_set_wasm } from "./template_web_bg.js";
__wbg_set_wasm(wasm);